














import { Component, Prop, VModel, Vue } from 'vue-property-decorator'

@Component
export default class LoanTypeSelect extends Vue {

    @Prop({ default: "Druh úvěru:" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;

    get items(): any[] {
        return [
          
        ];
    }

}
